import curry from 'utils/functional/curry'
import {
  DENTAL,
  VISION,
  LATITUDE,
  ECONOMY,
  QUANTUM,
  DELUXE,
  STANDARD,
  CORE,
  CHOICE,
  BTM,
  EPIC,
  SUPPLEMENTAL_BENEFIT,
  SURE_CARE
} from 'core/constants/products'
import getPlansByProductId from '.'

const products = [
  DENTAL,
  VISION,
  LATITUDE,
  ECONOMY,
  QUANTUM,
  DELUXE,
  STANDARD,
  CORE,
  CHOICE,
  BTM,
  EPIC,
  SUPPLEMENTAL_BENEFIT,
  SURE_CARE
]

const getStmAndBtm = curry(getPlansByProductId)({
  products: products
})

export default getStmAndBtm
